import { useEffect, useRef, useState } from '../../common/common';
import * as XLSX from 'xlsx';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { validateAddSubCategoryForm } from '../../validation/Authentication/Validation.js';
import { useErrorContext } from '../../context/ErrorContext';
import useNavigation from '../../common/useNavigation';
import useGetUserData from '../../secureAPI/GetUserData';

const MidViewCategories = (type) => {
    const { navigateDashboard } = useNavigation();
    const isMounted = useRef(true)
    const { users, userPlan, Remainuser, subUser } = useGetUserData();
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [seacrh, setSearch] = useState('');
    const [sheetdata, setSheetdata] = useState([]);
    const [showAddsubcategoryModal, setShowAddsubcategoryModal] = useState(false);
    const [showEditcategoryModal, setShowEditcategoryModal] = useState(false);

   
    const [originalCategoryImg, setOriginalCategoryImg] = useState(null);
    const [backCategoryId, setbackCategoryId] = useState([]);
    const [values, setvalues] = useState({
        editRowID: 0,
        subCategoryName: '',
        parentID: 0,
        ParentCategory: '',
        Categoryimg: '',
        fileImage: null,
    });
    const fileInputRef = useRef(null);
    useEffect(() => {
        showToast('', '');
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            // console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);

    useEffect(() => {
        isMounted.current = true;
        getCategories(categoryID);
        return () => {
            // Component unmount hone par flag false kar do
            isMounted.current = false;
        };
    }, []);


    //   useEffect(() => {
    //     getCategories(categoryID);
    // }, []);



    const logUserData = () => {
        // console.log({ users: users });
        const userTypes = users[0]['UserType'];
        const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
        // console.log({ usertypeArray: usertypeArray });

        const hasOne = usertypeArray.includes(1);
        const hasTwo = usertypeArray.includes(2);

        if (users?.length > 0) {
            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {
            }
            else {
                // alert();
                navigateDashboard('buyer');
            }
        }

    };
    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddSubCategoryForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setvalues(prevValues => ({ ...prevValues, [name]: value }));

        // console.log({ values: values });
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();

    };
    const handleFileChange = ({ target: { files } }) => {
        setvalues(prevValues => ({ ...prevValues, fileImage: files[0] }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
       
        const validationErrors = validateAndSetErrors(values);
        // console.log({ validationErrors: validationErrors });
        if (Object.keys(validationErrors).length === 0) {
             StartLoading(setisLoading);
            StopLoading(setisLoading)
            clearAllErrors();
            AddSubCategory(); // Assuming checkLogin() is a function to handle actual login logic
        }
    };

    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [categoryID, setCategoryID] = useState(0);
    const [imageUpdateFlag, setImageUpdateFlag] = useState(0);

    const handleShowModal = (id, name) => {
        setShowAddsubcategoryModal(true);
        setbackCategoryId(id);
        setvalues(prevValues => ({ ...prevValues, parentID: id }));
        setvalues(prevValues => ({ ...prevValues, ParentCategory: name }));
    };


    const handleCloseModal = () => setShowAddsubcategoryModal(false);

    const handleShowEditModal = (uid, id, name, category_img) => {
        // console.log('id is ' + id + 'name is' + name + 'img is : ' + category_img);
        setOriginalCategoryImg(category_img); // 🔴 BACKUP SAVE
        setImageUpdateFlag(0);
        setShowEditcategoryModal(true);
        setvalues(prevValues => ({ ...prevValues, editRowID: uid, parentID: id, subCategoryName: name, Categoryimg: category_img }));

    };
    // console.log({ values: values });
    const handleCloseEditModal = () => {
        setvalues(prev => ({
            ...prev,
            Categoryimg: originalCategoryImg, // ✅ restore image
            fileImage: null,
        }));

        setImageUpdateFlag(0);
        setShowEditcategoryModal(false);
    }

    const deleteImage = () => {


        setImageUpdateFlag(1);
        setvalues(prev => ({
            ...prev,
            Categoryimg: null,
            fileImage: null,
        }));

        // setvalues(prevValues => ({ ...prevValues, Categoryimg: null }));
        // setvalues(prevValues => ({ ...prevValues, fileImage: null }));
    }



    const exporttoExcelData = () => {
        var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(sheetdata);
        XLSX.utils.book_append_sheet(wb, ws, 'Product Category');
        XLSX.writeFile(wb, "Selzor_Product_Categories.xlsx");
    }

    // useEffect(() => {
    //     isMounted.current = true;
    //     getCategories(0);
    //     return () => {
    //         // Component unmount hone par flag false kar do
    //         isMounted.current = false;
    //     };
    // }, []);


    useEffect(() => {
        const filtered_result = categories.filter((category) => {
            return (
                category.name.toLowerCase().match(seacrh.toLowerCase())
            );
        });
        setFilteredCategories(filtered_result);
    }, [seacrh]);

    const handleGoBackToParent = () => {
        // console.log("Going back from current category:", values.parentID);

        if (values.parentID !== 0 && values.parentID !== undefined) {
            getCategories(values.parentID); // Fetch the parent category's level
            setvalues(prev => ({
                ...prev,
                parentID: 0 // optional: keep going up
            }));
        } else {
            getCategories(0); // fallback to main categories
        }
    };





    const AddSubCategory = async () => {
        StartLoading(setisLoading);
        const categoryParentID = values.parentID;
        const catName = values.subCategoryName;
        const fileImage = values.fileImage;

        var formData = new FormData();
        formData.append("CategoryName", catName);
        formData.append("parentID", categoryParentID);
        formData.append("app", 0);
        if (fileImage) { formData.append("fileImage", fileImage); }
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddCategories`, formData, { withCredentials: true, timeout: 10000 })
                .then(async (response) => {
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        // console.log(response.data);
                        showToast(response.data.message, 'success');

                        values.subCategoryName = "";
                        values.fileImage = null;
                        // setCategories(response.data.categories);
                        // setFilteredCategories(response.data.categories);
                        // setSheetdata(response.data.categories);
                        // setbackCategoryId((prevValues) => {
                        //     if (Array.isArray(prevValues)) {
                        //         return [...prevValues, categoryID]; // Only spread if it's an array
                        //     }
                        // });
                        handleCloseModal();
                        setTimeout(() => {
                            getCategories(categoryParentID);
                        }, 2000); // Waits for 2 seconds (2000 milliseconds)

                        // await new Promise(resolve => setTimeout(resolve, 500));
                        // try {
                        //     await getCategories(categoryParentID);
                        // } catch (fetchError) {
                        //     console.error("Failed to refresh categories:", fetchError);
                        //     // Optionally retry or show a warning
                        // }
                        // getCategories(categoryParentID);
                        // StopLoading(setisLoading)
                    }
                    else {
                        StopLoading(setisLoading)
                        // showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading);
                    // console.error("Caught error from API call:", err);
                    if (err.response) {
                        const status = err.response.status;
                        const message = err.response.data?.message || 'Server error occurred.';
                        // console.log("Error response:", err.response);

                        if (status === 409) {
                            // showToast(message || 'Product already exists.', 'error');
                        } else if (status === 400) {
                            showToast("Missing required fields.", 'error');
                        } else {
                            showToast(message, 'error');
                        }
                    } else if (err.request) {
                        showToast('No response from server. Please try again later.', 'error');
                    } else {
                        showToast(err.message || 'Unexpected error occurred.', 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Add Category, please try again later ", 'error');
        }
    }


    const handleEditSubmit = (e) => {
        e.preventDefault();
        StartLoading(setisLoading);
        const validationErrors = validateAndSetErrors(values);
        // console.log({ validationErrors: validationErrors });
        if (Object.keys(validationErrors).length === 0) {
            StopLoading(setisLoading)
            clearAllErrors();
            EditSubmit(); // Assuming checkLogin() is a function to handle actual login logic
        }
    };
    const EditSubmit = async () => {
        StartLoading(setisLoading);
        const categoryEditID = values.editRowID;
        const catName = values.subCategoryName;
        const fileImage = values.fileImage;

        var formData = new FormData();
        formData.append("catname", catName);
        formData.append("editid", categoryEditID);
        formData.append("imageFlag", imageUpdateFlag);
        formData.append("app", 0);

        if (fileImage) { formData.append("fileImage", fileImage); }
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/EditCategories`, formData, { withCredentials: true, })
                .then((response) => {
                    // console.log(response.data);
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        setImageUpdateFlag(0)
                        // console.log(response.data);

                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        values.subCategoryName = "";
                        handleCloseEditModal();
                        setTimeout(() => {
                            getCategories(categoryEditID);
                        }, 2000); // Waits for 2 seconds (2000 milliseconds)
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading);
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Update Category, please try again later ", 'error');
        }


    }
    const gobackCategory = () => {
        // alert(backCategoryId);

        if (backCategoryId.length > 0) {
            // console.log(backCategoryId[backCategoryId.length - 2]);
            getCategories(backCategoryId[backCategoryId.length - 2]);
            const newBackCategoryId = backCategoryId.slice(0, backCategoryId.length - 2);
            setbackCategoryId(newBackCategoryId);

        }
        return null;
    }
    const getCategories = async (categoryID) => {

        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetCategories`, { categoryID }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    // console.log(response.data);
                    if (response.data.success === 1) {
                        showToast(response.data.message, 'success');
                        setCategories(response.data.data);
                        setFilteredCategories(response.data.data);
                        setSheetdata(response.data.data);
                        setbackCategoryId((prevValues) => {
                            if (Array.isArray(prevValues)) {
                                return [...prevValues, categoryID]; // Only spread if it's an array
                            }
                            // return [categoryID]; // Default case, if prevValues is not an array
                        });
                        // setbackCategoryId(prevValues => [...prevValues, categoryID]);
                    }
                    else {
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Get Categories, please try again later ", 'error');
        }
    };



    const deleteCategory = async (deleteCategory_id) => {
        if (window.confirm("Are you sure you want to delete Category?")) {
            StartLoading(setisLoading);
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/DeleteCategory`, { deleteCategoryid: deleteCategory_id, app: 0 }, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {

                        StopLoading(setisLoading)
                        showToast(res.data.message, 'success');
                        // data_len = res.data.data.length;

                        setCategories(res.data.data);
                        setFilteredCategories(res.data.data);
                    }
                    else if (res.data.success === 0) {

                        StopLoading(setisLoading)
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('something went wrong ! please try later', 'error');
                });
        }

    }
    const handleToggleStatus = async (rowId, check) => {
        // console.log(rowId);
        if (rowId !== "") {
            StartLoading(setisLoading);
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/CategoryActiveToggle`, { category: rowId, check, app: 0 }, { withCredentials: true })
                    .then((response) => {
                        if (!isMounted.current) return;
                        StopLoading(setisLoading);
                        // console.log(response.data);
                        if (response.data.success === 1) {

                            StopLoading(setisLoading)
                            showToast(response.data.message, 'success');
                            setTimeout(() => {
                                getCategories(0);
                            }, 2000); // Waits for 2 seconds (2000 milliseconds)
                            // setFilteredProducts([]);
                            setSheetdata(response.data.data);
                        }
                        else {
                            StopLoading(setisLoading)
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        if (!isMounted.current) return;
                        const res_status = err.response.data.success;
                        const res_message = err.response.data.message;
                        if (res_status !== "" && res_message !== "") { }
                        else if (err.status === 401) {
                            // logout();
                        }
                        else {
                            showToast(err.data.message, 'error');
                        }
                    });
            } catch (err) {
                if (!isMounted.current) return;
                StopLoading(setisLoading);
                showToast("Failed to Delete Product, please try again later ", 'error');
            }
        }

        // Toggle logic here (maybe API call or state update)
        // const updatedStatus = row.is_visible === 1 ? 0 : 1;

        // console.log("Toggling status for row ID:", row.id);
        // console.log("New status:", updatedStatus);

        // Example: If you're calling an API
        // axios.post('/api/toggle-status', { id: row.id, is_visible: updatedStatus })

        // Or update local state if needed
    };


    return { users, userPlan, Remainuser, subUser, seacrh, setSearch, exporttoExcelData, deleteCategory, isDisabled, filteredCategories, isLoading, getCategories, AddSubCategory, handleShowModal, handleCloseModal, showAddsubcategoryModal, setShowAddsubcategoryModal, handleSubmit, values, handleChange, gobackCategory, handleFileChange, showEditcategoryModal, setShowEditcategoryModal, handleShowEditModal, handleCloseEditModal, deleteImage, handleEditSubmit, handleGoBackToParent, setvalues, handleToggleStatus,  }
}

export default MidViewCategories